/*
 * @Author: Claude (Refactored v2)
 * @Date: 2025-12-31
 * @Description: 图片上传组件（Upload 组件的快捷方式）
 */
import { FC } from 'react';

import { GridMediaPreviewItem } from '../common/components/GridMediaPreviewItem';
import { UploadPlaceholder } from '../common/components/UploadPlaceholder';
import { defaultConfig } from '../config';
import { Upload } from '../core/Upload';
import { ImageUploadProps } from './types';

/**
 * 图片上传组件
 * 支持图片文件的上传、预览和删除
 * 本质上是 Upload 组件的预配置版本（previewType="image-grid"）
 */
const ImageUpload: FC<ImageUploadProps> = (props) => {
  const { children, tips, selectable = false, feature, ...restProps } = props;

  return (
    <Upload
      {...restProps}
      previewType="image-grid"
      config={defaultConfig}
      selectable={selectable}
      feature={feature}
      enableTracking={!!feature}
      uploadPlaceholder={<UploadPlaceholder tips={tips} />}
      renderPreview={{
        grid: (file, onDelete, onSelect) => (
          <GridMediaPreviewItem
            key={file.uid}
            file={file}
            mediaType="image"
            selectable={selectable}
            onDelete={onDelete}
            onSelect={onSelect}
          />
        ),
      }}
    >
      {children}
    </Upload>
  );
};

export default ImageUpload;
